var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",class:{ noscroll: _vm.status },attrs:{"id":"app"}},[_c('keep-alive',[(_vm.isRouterAlive && _vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(
        _vm.isRouterAlive &&
          (_vm.$route.meta.keepAlive == undefined || !_vm.$route.meta.keepAlive)
      )?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21cbd6f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 